import React from "react";
import ieeelogo from "../../assets/ieeelogo.png";
import CGCimage from "../../assets/CGC-image.png";
import homeBanner from "../../assets/cgcHomeBanner.png";
const dates = [
  {
    label: "Paper Submission Deadline:",
    date: "31st July, 2025",
    otherdate:"10th November, 2026",
  },
  {
    label: "Acceptance Notification:",
    date: "8th Sept, 2025",
    otherdate:"18th January, 2027",
  },
  {
    label: "Camera Ready Paper Submission Deadline:",
    date: "8th Oct, 2025",
    otherdate:"20th Feb, 2027",
  },
  {
    label: "Registration Deadline:",
    date: "8th Oct, 2025",
    otherdate:"28th Feb, 2027"
  },
  {
    label: "Conference Date:",
    date: "18th – 20th Mar, 2026",
    otherdate:"18th – 20th Mar, 2027"
  }
];

function Home() {
  return (
    <div className=" mt-5 relative w-full min-h-screen bg-cover bg-center bg-no-repeat py-16">
      <div 
        className="absolute inset-0 z-0 bg-no-repeat" 
        style={{
          backgroundImage: `url('${homeBanner}')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          filter: "brightness(0.7)"
        }}
      />
      
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center justify-center min-h-[calc(100vh-8rem)]">
        {/* Main Title */}
        <div className="text-white text-xl md:text-2xl lg:text-3xl tracking-wider font-extrabold mb-8 text-center">
          <div>
            IETACS-2027 <br />
            <span style={{fontSize: '20px'}}>
                (2<sup>nd</sup> International Conference on Innovations And Emerging Technologies In AI & Communication Systems)   
            </span>
            <br />
            <span style={{color:'#ef4444'}}>
                Unifying AI and Communication for a Smarter Tomorrow
            </span>
            <br />
            {/* <span style={{fontSize: '1.5rem'}}>
                Conference Record No. # 68750
            </span> */ }
          </div>
        </div>

        {/* Content Container */}
        <div className="w-full max-w-6xl">
          <div className="flex flex-col lg:flex-row gap-8 mb-8 justify-center">
            {/* IEEE Notice */}
            {/* <div className="lg:w-1/2 flex items-center" style={{display: 'none'}}>
            </div> */}

            {/* Important Dates */}
            <div className="lg:w-1/2">
              <h4 className="text-white font-bold text-lg md:text-xl lg:text-2xl mb-4">
                Important Dates:
              </h4>
              <div>
  <table className="w-full">
    <tbody>
      {dates.map((item, index) => (
        <tr key={index} className=" text-white transition-colors">
          <td className="py-1.5 px-3 text-xs md:text-sm lg:text-base font-medium">
            {item.label}
          </td>
          { /* <td className="py-1.5 px-3 text-xs md:text-sm lg:text-base font-medium text-right">
            {index < 4 ? <strike style={{ textDecoration: 'line-through', textDecorationColor: 'red'}}>{item.date}</strike> : item.date}            
          </td>  */ }
          <td className="py-1.5 px-3 text-xs md:text-sm lg:text-base font-medium text-right">
            <span>{item.otherdate}</span>
            {/* index < 4 ? <span>{item.otherdate}</span> : item.otherdate */}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
            </div>
          </div>

          {/* Organization Details */}
          <div className="text-center text-white text-base md:text-lg lg:text-xl font-semibold mt-8">
            <p className="mb-2">Organised by</p>
            <p className="mb-2">School of Engineering & Technology</p>
            <p className="mb-2">CGC University, Mohali</p>
            {/* <p className="mb-2">Chandigarh Group of Colleges, Jhanjeri, Mohali,</p> */ }
            <p>Punjab-140307</p>
            <p>&nbsp;</p>
            {/* <p className="text-white text-base md:text-lg italic text-right">* Applied for</p>*/ }
          </div>
        </div>
      </div>
    </div>
  );
}
export default Home;
